import React from 'react'
function PaymentCompletion() {
  return <h1 style={{
    position: "absolute",
    margin: "auto",
    marginTop: "calc(20% - 15px)",
    lineHeight: "30px",
    width: "100%",
    textAlign: "center",
  }}>Thank you! 🎉</h1>;
}

export default PaymentCompletion;